import { Model, Attr, HasOne } from 'spraypaint';
import ApplicationRecord from './ApplicationRecord';
import { User, Price } from './';

@Model()
export default class CheckoutSession extends ApplicationRecord {
  static jsonapiType = 'checkout-sessions';

  static scopeFactory() {
    return CheckoutSession.includes([]);
  }

  @Attr() sessionId: string;

  @HasOne() user: User;
  @HasOne() price: Price;
}
